export default __webpack_public_path__ + "static/media/PPI-firefeature-004.25780dc8.jpg";